import { Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterMatchMode } from 'primeng/api';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { translationSchema } from '@well/translation';
import { ColumnFilterComponentBase } from '@irian-ro/table-column-filter';
import { Select, SelectModule } from 'primeng/select';

@Component({
  selector: 'lib-dropdown-filter',
  standalone: true,
  imports: [
    CommonModule,
    SelectModule,
    PrimengUtilsModule,
    SharedComponentsModule,
    TranslateModule,
    FormsModule,
    Select,
  ],
  templateUrl: './dropdown-filter.component.html',
  styleUrl: './dropdown-filter.component.scss',
})
export class DropdownFilterComponent implements ColumnFilterComponentBase {
  @Input() options: unknown[] = [];
  @Input() filterMatchMode = FilterMatchMode.EQUALS;
  @Input() value: string | null = null;
  @Input() dataCy = '';
  @Input() showClear = true;

  filtersChange = output<FilterMetadata>();

  select(value: any) {
    const filterMetadata: FilterMetadata = {
      value: value,
      matchMode: this.filterMatchMode,
    };
    this.filtersChange.emit(filterMetadata);
  }

  protected readonly translationSchema = translationSchema;
}

